// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   KNOWLEDGE UPLOAD COMPONENT STYLES - LIGHT THEME
   =========================================== */

:root {
  /* Colors */
  --primary-color: #3b82f6;
  --primary-dark: #1e40af;
  --primary-light: #2563eb;
  --secondary-dark: #f5f5f5;
  --secondary-darker: #ffffff;
  --text-primary: #1a1a1a;
  --text-secondary: #4a4a4a;
  --text-muted: #6b7280;
  --border-color: #e0e0e0;
  --border-light: #d0d0d0;
  --success: #10b981;
  --warning: #f59e0b;
  --error: #ef4444;
  --bg-card: #ffffff;
  --bg-input: #f9f9f9;

  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);

  /* Transitions */
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ==========================================
   GLOBAL STYLES
   =========================================== */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* ==========================================
   KNOWLEDGE UPLOAD CONTAINER
   =========================================== */

.knowledge-upload-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 50%, #f0f0f0 100%);
  padding: 15px;
}

/* ==========================================
   HEADER SECTION
   =========================================== */

.upload-header {
  /* margin-bottom: 10px; */
  border: 1px solid #d0d0d0;
  border-radius: 12px;
  padding: 18px;
  background: linear-gradient(135deg, #ffffff 0%, #f9f9f9 100%);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.header-content {
  max-width: 100%;
}

.phase-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: var(--primary-light);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.phase-icon {
  font-size: 14px;
}

.header-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--text-primary);
  letter-spacing: -0.5px;
}

.header-description {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.6;
}

/* ==========================================
   STEPS PROGRESS
   =========================================== */

.steps-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  /* margin-bottom: 15px; */
  overflow-x: auto;
  padding: 16px 0;
}

.step {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: var(--transition);
  min-width: fit-content;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--bg-input);
  border: 2px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  color: var(--text-muted);
  transition: var(--transition);
}

.step.active .step-number {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
  box-shadow: 0 0 20px rgba(59, 130, 146, 0.3);
}

.step.current .step-number {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
  transform: scale(1.15);
  box-shadow: 0 0 30px rgba(59, 130, 246, 0.5);
}

.step-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-muted);
  transition: var(--transition);
}

.step.active .step-label,
.step.current .step-label {
  color: var(--primary-light);
}

.step-divider {
  width: 24px;
  height: 2px;
  background: var(--border-color);
  margin: 0 4px;
  flex-shrink: 0;
}

.step.active ~ .step-divider {
  background: var(--primary-color);
}

/* ==========================================
   UPLOAD CONTENT LAYOUT
   =========================================== */

.upload-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  max-width: 1400px;
  margin: 10px auto;
}

@media (max-width: 1024px) {
  .upload-content {
    grid-template-columns: 1fr;
  }
}

/* ==========================================
   CARD STYLES
   =========================================== */

.upload-card,
.config-card,
.log-card {
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  backdrop-filter: blur(10px);
  overflow: hidden;
  transition: var(--transition);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.upload-card:hover,
.config-card:hover,
.log-card:hover {
  border-color: var(--border-light);
  box-shadow: 0 20px 40px rgba(59, 130, 246, 0.1);
}

.card-header-KB {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-bottom: 1px solid var(--border-color);
  color: var(--text-primary);
  position: relative;
  /* background: #e6eeffeb; */
  background: linear-gradient(135deg, #dbedff 0%, #f3f4f6 100%);
}

.card-header-KB h2,
.card-header-KB h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  flex: 1 1;
}

.card-header-KB svg {
  width: 20px;
  height: 20px;
  color: var(--primary-light);
}

.format-btn {
  padding: 4px 12px;
  border: 1px solid var(--border-light);
  border-radius: 20px;
  background: transparent;
  color: var(--primary-light);
  font-size: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
}

.format-btn:hover {
  background: rgba(59, 130, 246, 0.05);
  border-color: var(--primary-light);
}

/* ==========================================
   FORMS
   =========================================== */

.upload-form,
.config-form {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* .form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.form-group label {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.form-select {
    padding: 12px 14px;
    border: 1px solid var(--border-light);
    border-radius: 8px;
    background: var(--bg-input);
    color: var(--text-primary);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: var(--transition);
    appearance: none;
    padding-right: 36px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%234a4a4a' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
}

.form-select:focus,
.form-select:hover {
    border-color: var(--primary-light);
    background-color: rgba(59, 130, 246, 0.05);
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-select option {
    background: white;
    color: var(--text-primary);
}*/

.material-type-select,
.depth-select {
  position: relative;
  display: flex;
  align-items: center;
}

.material-type-select svg,
.depth-select svg {
  position: absolute;
  left: 14px;
  width: 16px;
  height: 16px;
  color: var(--primary-light);
  pointer-events: none;
}

.material-type-select,
.depth-select {
  padding-left: 40px;
}

.select-icon {
  position: absolute;
  right: 12px;
  width: 18px;
  height: 18px;
  color: var(--text-muted);
  pointer-events: none;
}

/* ==========================================
   DRAG AND DROP AREA
   =========================================== */

.drag-drop-area {
  border: 2px dashed var(--border-light);
  border-radius: 10px;
  padding: 5px 5px;
  text-align: center;
  cursor: pointer;
  transition: var(--transition);
  background: rgba(59, 130, 246, 0.02);
  position: relative;
  overflow: hidden;
}

.drag-drop-area::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    circle at center,
    rgba(59, 130, 246, 0.03) 0%,
    transparent 70%
  );
  pointer-events: none;
}

.drag-drop-area.active {
  border-color: var(--primary-light);
  background: rgba(59, 130, 246, 0.08);
  box-shadow: 0 0 30px rgba(59, 130, 246, 0.2);
}

.drag-drop-area:hover {
  border-color: var(--primary-color);
  background: rgba(59, 130, 246, 0.04);
}

.upload-icon {
  width: 24px;
  height: 24px;
  color: var(--primary-light);
  margin: 0 auto 16px;
  opacity: 0.8;
  transition: var(--transition);
}

.drag-drop-area:hover .upload-icon,
.drag-drop-area.active .upload-icon {
  opacity: 1;
  transform: scale(1.1);
}

.drag-drop-area h3 {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.drag-drop-area p {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 16px;
}

.format-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 16px;
}

.format-badge {
  padding: 4px 10px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  color: var(--primary-light);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.file-input {
  display: none;
}

/* ==========================================
   URL INPUT SECTION
   =========================================== */

.url-input-section {
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
}

.url-input-section label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.url-input-group {
  display: flex;
  gap: 8px;
}

.url-input {
  flex: 1 1;
  padding: 10px 14px;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 13px;
  transition: var(--transition);
}

.url-input:focus {
  outline: none;
  border-color: var(--primary-light);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.url-input::placeholder {
  color: var(--text-muted);
}

.add-btn {
  padding: 10px 16px;
  background: var(--primary-color);
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.add-btn:hover {
  background: var(--primary-dark);
  box-shadow: 0 0 20px rgba(59, 130, 246, 0.3);
}

.add-btn:active {
  transform: scale(0.98);
}

/* ==========================================
   UPLOAD QUEUE
   =========================================== */

.upload-queue {
  border-top: 1px solid var(--border-color);
  padding: 20px;
  background: rgba(59, 130, 246, 0.02);
}

.upload-queue h3 {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.queue-count {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 12px;
}

.no-files {
  text-align: center;
  padding: 24px;
  color: var(--text-muted);
  font-size: 13px;
}

.files-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
}

.files-list::-webkit-scrollbar {
  width: 6px;
}

.files-list::-webkit-scrollbar-track {
  background: rgba(59, 130, 246, 0.05);
  border-radius: 3px;
}

.files-list::-webkit-scrollbar-thumb {
  background: rgba(59, 130, 246, 0.3);
  border-radius: 3px;
}

.files-list::-webkit-scrollbar-thumb:hover {
  background: rgba(59, 130, 246, 0.5);
}

.file-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  transition: var(--transition);
}

.file-item:hover {
  background: #fafafa;
  border-color: var(--border-light);
}

.file-progress .progress {
  width: 100%;
  height: 4px;
  background: #f1f5f9;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #22c55e);
  /* 🔥 blue → green */
  transition: width 0.4s ease;
}

.file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.file-info {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}

.file-info svg {
  width: 16px;
  height: 16px;
  color: var(--primary-light);
  flex-shrink: 0;
  margin-top: 2px;
}

.file-details {
  min-width: 0;
}

.file-name {
  max-width: 440px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-meta {
  font-size: 11px;
  color: var(--text-muted);
}

.remove-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: #fef2f2;
  color: #ef4444;
  font-size: 18px;
  font-weight: 600;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.remove-btn:hover {
  background: #ef4444;
  color: #fff;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.remove-btn:active {
  transform: scale(0.95);
}

/* ==========================================
   EXTRACTION CONFIG
   =========================================== */

.config-form {
  padding: 24px;
}

.year-range {
  display: flex;
  gap: 12px;
  align-items: center;
}

.year-input {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid var(--border-light);
  border-radius: 6px;
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 13px;
  transition: var(--transition);
}

.year-input:focus {
  outline: none;
  border-color: var(--primary-light);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.year-separator {
  color: var(--text-muted);
  font-size: 13px;
  white-space: nowrap;
}

/* ==========================================
   EXTRACTION OPTIONS
   =========================================== */

.extraction-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: rgba(59, 130, 246, 0.03);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: var(--transition);
}

.checkbox-label:hover {
  color: var(--primary-light);
}

.checkbox-input {
  display: none;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid var(--border-light);
  border-radius: 4px;
  background: white;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.checkbox-input:checked + .checkbox-custom {
  background: var(--primary-color);
  border-color: var(--primary-color);
}

.checkbox-input:checked + .checkbox-custom::after {
  content: "✓";
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.label-text {
  font-size: 13px;
  color: var(--text-secondary);
  transition: var(--transition);
}

.checkbox-label:hover .label-text {
  color: var(--text-primary);
}

/* ==========================================
   START BUTTON
   =========================================== */

.start-btn {
  padding: 12px 20px;
  background: linear-gradient(
    135deg,
    var(--primary-color) 0%,
    var(--primary-dark) 100%
  );
  border: 1px solid var(--primary-light);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 8px;
}

.start-btn:hover {
  box-shadow: 0 0 30px rgba(59, 130, 246, 0.4);
  transform: translateY(-2px);
}

.start-btn:active {
  transform: translateY(0);
}

.start-btn svg {
  width: 18px;
  height: 18px;
}
.start-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
  box-shadow: none;
}

/* ==========================================
   PROCESSING LOG
   =========================================== */

.log-card {
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  grid-column: 1 / -1;
  height: -moz-available;
  height: -webkit-fill-available;
  height: stretch;
}

@media (min-width: 1025px) {
  .log-card {
    margin-top: 0;
    grid-column: 2;
    grid-row: 2;
  }
}

.log-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color);
  /* background: #e6eeffeb; */
  background: linear-gradient(135deg, #dbedff 0%, #f3f4f6 100%);
}

.log-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  flex: 1 1;
}

.log-status {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.log-content {
  padding: 16px;
  background: #f5f5f5;
  font-family: "Courier New", monospace;
  font-size: 12px;
  /* color: var(--primary-color); */
  max-height: 743px;
  overflow-y: auto;
  flex: 1 1;
}

.log-content::-webkit-scrollbar {
  width: 6px;
}

.log-content::-webkit-scrollbar-track {
  background: rgba(59, 130, 246, 0.05);
}

.log-content::-webkit-scrollbar-thumb {
  background: rgba(59, 130, 246, 0.2);
  border-radius: 3px;
}

.log-line {
  line-height: 1.8;
  white-space: pre-wrap;
  word-break: break-word;
  margin-bottom: 4px;
}

.log-line:last-child {
  margin-bottom: 0;
}

/* ==========================================
   CARD STYLES
   =========================================== */

.quick-templates-card,
.ai-command-card,
.advanced-params-card,
.output-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  /* border-radius: 12px; */
  overflow: hidden;
  box-shadow: var(--shadow-md);
  transition: var(--transition);
  position: relative;
  bottom: 0;
  right: 0;
  width: -moz-available;
  width: -webkit-fill-available;
  width: stretch;
}

.quick-templates-card:hover,
.ai-command-card:hover,
.advanced-params-card:hover,
.output-card:hover {
  border-color: var(--primary-light);
  box-shadow: 0 12px 24px rgba(37, 99, 235, 0.12);
}

.card-header-Ai {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: linear-gradient(135deg, #dbedff 0%, #f3f4f6 100%);
  border-bottom: 1px solid var(--border-color);
  position: relative;
  /* border-top-left-radius: 5px;
  border-top-right-radius: 5px; */
}

.header-icon {
  width: 18px;
  height: 18px;
  color: var(--primary-color);
  flex-shrink: 0;
}

.card-header-Ai h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  flex: 1 1;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

/* .claude-response {
  height: 100vh;
  overflow: auto;
} */

/* ==========================================
   AI COMMAND CARD
   =========================================== */

.command-input-section {
  padding: 16px;
}

.input-wrapper {
  position: relative;
  display: flex;
  gap: 12px;
  /* margin-bottom: 16px; */
}

.command-input {
  flex: 1 1;
  padding: 14px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 13px;
  font-family: "Segoe UI", Roboto, sans-serif;
  resize: vertical;
  min-height: 100px;
  transition: var(--transition);
}

.command-input:focus {
  outline: none;
  border-color: var(--primary-color);
  background: white;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.command-input::placeholder {
  color: var(--text-light);
}

.send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #abaeff, #4f46e5);
  color: white;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

/* Hover */
.send-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(99, 102, 241, 0.4);
}

/* Click */
.send-btn:active {
  transform: scale(0.95);
}

/* Disabled */
.send-btn:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
  box-shadow: none;
}

.input-hint {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 3px;
  font-weight: 600;
}

/* ==========================================
   EXECUTE BUTTON
   =========================================== */

.execute-btn {
  padding: 9px 20px;
  /* margin: 0 16px 20px; */
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: calc(100% - 48px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.execute-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
}

.execute-btn:active {
  transform: translateY(0);
}

.execute-btn svg {
  width: 18px;
  height: 18px;
}

.execute-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.trash-icon {
  /* position: absolute; */
  /* right: 20px;
    bottom: 20px; */
  padding: 8px;
  background: var(--bg-input);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  color: var(--text-muted);
  cursor: pointer;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
}

.trash-icon:hover {
  background: #fee2e2;
  border-color: var(--error);
  color: var(--error);
}

/* ==========================================
   RESPONSIVE DESIGN
   =========================================== */

@media (max-width: 1024px) {
  .knowledge-upload-container {
    padding: 24px 16px;
  }

  .header-title {
    font-size: 24px;
  }

  .upload-content {
    gap: 16px;
  }

  .log-card {
    grid-column: 1 / -1;
    margin-top: 0;
  }
}

@media (max-width: 768px) {
  .knowledge-upload-container {
    padding: 16px 12px;
  }

  .upload-header {
    padding: 16px;
    margin-bottom: 24px;
  }

  .header-title {
    font-size: 20px;
  }

  .header-description {
    font-size: 13px;
  }

  .steps-container {
    gap: 8px;
    margin-bottom: 24px;
  }

  .upload-form,
  .config-form {
    gap: 16px;
  }

  .drag-drop-area {
    padding: 32px 16px;
  }

  .url-input-group {
    flex-direction: column;
  }

  .add-btn {
    width: 100%;
    justify-content: center;
  }

  .year-range {
    flex-wrap: wrap;
  }

  .year-input {
    flex: 1 1;
    min-width: 100px;
  }
}

/* ==========================================
   ANIMATIONS
   =========================================== */

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

.knowledge-upload-container {
  animation: slideIn 0.6s ease-out;
}

.step {
  animation: slideIn 0.6s ease-out backwards;
}

.step:nth-child(odd) {
  animation-delay: 0.1s;
}

.step:nth-child(even) {
  animation-delay: 0.2s;
}

/* ==========================================
   UTILITY CLASSES
   =========================================== */

.opacity-50 {
  opacity: 0.5;
}

.cursor-pointer {
  cursor: pointer;
}

.transition-all {
  transition: var(--transition);
}

.image-card {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  border: 1px solid #c6c6c6;
  cursor: default;
  transition: 0.25s ease;
}

.image-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 0px 10px rgb(0 0 0 / 12%);
  border-color: #4f8cff;
  border-width: 2px;
}

.image-card.editing {
  border: 2px solid #4f8cff;
  cursor: pointer;
}

/* Image */
.image-card img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 270px;
}

/* Placeholder */
.placeholder {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #aaa;
}

.plus {
  font-size: 26px;
  margin-bottom: 6px;
}

/* Overlay Button */
.overlay {
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 0;
  transition: 0.2s ease;
}

.image-card:hover .overlay {
  opacity: 1;
}

.overlay button:hover {
  background: rgb(195, 246, 255);
  border: 1px solid #00b1cc;
}

.overlay button {
  background: rgb(255 255 255);
  border: none;
  border-radius: 19%;
  padding: 6px 8px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid #414141;
}

.overlay button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.image-card.editing .overlay {
  opacity: 1;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 15px 0;
}

.page-btn {
  min-width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #414141;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.page-btn:hover {
  background: #78909c59;
  font-weight: 600;
}

.page-btn.active {
  background: #2563eb;
  color: #fff;
  font-weight: 600;
}

.nav-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  background: #2461e5;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-btn:hover {
  background: #ffffff;
  color: #2461e5;
  border: 2px solid #2461e5;
}

.nav-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/Screen/AIPanel/knowledgeBaseUpload/knowledgeBaseUpload.css"],"names":[],"mappings":"AAAA;;gDAEgD;;AAEhD;EACE,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;;EAEnB,YAAY;EACZ,0CAA0C;EAC1C,yCAAyC;EACzC,2CAA2C;EAC3C,2CAA2C;;EAE3C,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;;gDAEgD;;AAEhD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;gDAEgD;;AAEhD;EACE,iBAAiB;EACjB,0EAA0E;EAC1E,aAAa;AACf;;AAEA;;gDAEgD;;AAEhD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;gDAEgD;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;EACZ,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;gDAEgD;;AAEhD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;gDAEgD;;AAEhD;;;EAGE,qCAAqC;EACrC,mBAAmB;EACnB,6DAA6D;EAC7D,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;;;EAGE,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,4CAA4C;EAC5C,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,6DAA6D;AAC/D;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;;gDAEgD;;AAEhD;;EAEE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0CE;;AAEF;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;;gDAEgD;;AAEhD;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;GAIC;EACD,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;gDAEgD;;AAEhD;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;gDAEgD;;AAEhD;EACE,yCAAyC;EACzC,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;gDAEgD;;AAEhD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;gDAEgD;;AAEhD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;gDAEgD;;AAEhD;EACE,kBAAkB;EAClB;;;;GAIC;EACD,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;gDAEgD;;AAEhD;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAe;EAAf,8BAAe;EAAf,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,2BAA2B;EAC3B,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;gDAEgD;;AAEhD;;;;EAIE,0BAA0B;EAC1B,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,qBAAc;EAAd,6BAAc;EAAd,cAAc;AAChB;;AAEA;;;;EAIE,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6DAA6D;EAC7D,4CAA4C;EAC5C,kBAAkB;EAClB;iCAC+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;;;GAGG;;AAEH;;gDAEgD;;AAEhD;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,UAAU;AACV;EACE,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;gDAEgD;;AAEhD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB;mBACiB;EACjB,YAAY;EACZ,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;gDAEgD;;AAEhD;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;AACF;;AAEA;;gDAEgD;;AAEhD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;gDAEgD;;AAEhD;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* ==========================================\n   KNOWLEDGE UPLOAD COMPONENT STYLES - LIGHT THEME\n   =========================================== */\n\n:root {\n  /* Colors */\n  --primary-color: #3b82f6;\n  --primary-dark: #1e40af;\n  --primary-light: #2563eb;\n  --secondary-dark: #f5f5f5;\n  --secondary-darker: #ffffff;\n  --text-primary: #1a1a1a;\n  --text-secondary: #4a4a4a;\n  --text-muted: #6b7280;\n  --border-color: #e0e0e0;\n  --border-light: #d0d0d0;\n  --success: #10b981;\n  --warning: #f59e0b;\n  --error: #ef4444;\n  --bg-card: #ffffff;\n  --bg-input: #f9f9f9;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);\n  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);\n\n  /* Transitions */\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* ==========================================\n   GLOBAL STYLES\n   =========================================== */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* ==========================================\n   KNOWLEDGE UPLOAD CONTAINER\n   =========================================== */\n\n.knowledge-upload-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 50%, #f0f0f0 100%);\n  padding: 15px;\n}\n\n/* ==========================================\n   HEADER SECTION\n   =========================================== */\n\n.upload-header {\n  /* margin-bottom: 10px; */\n  border: 1px solid #d0d0d0;\n  border-radius: 12px;\n  padding: 18px;\n  background: linear-gradient(135deg, #ffffff 0%, #f9f9f9 100%);\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.header-content {\n  max-width: 100%;\n}\n\n.phase-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: rgba(59, 130, 246, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--primary-light);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.phase-icon {\n  font-size: 14px;\n}\n\n.header-title {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 12px;\n  color: var(--text-primary);\n  letter-spacing: -0.5px;\n}\n\n.header-description {\n  font-size: 15px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n/* ==========================================\n   STEPS PROGRESS\n   =========================================== */\n\n.steps-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  /* margin-bottom: 15px; */\n  overflow-x: auto;\n  padding: 16px 0;\n}\n\n.step {\n  display: flex;\n  /* flex-direction: column; */\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: var(--transition);\n  min-width: fit-content;\n}\n\n.step-number {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--bg-input);\n  border: 2px solid var(--border-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 16px;\n  color: var(--text-muted);\n  transition: var(--transition);\n}\n\n.step.active .step-number {\n  background: var(--primary-color);\n  border-color: var(--primary-color);\n  color: white;\n  box-shadow: 0 0 20px rgba(59, 130, 146, 0.3);\n}\n\n.step.current .step-number {\n  background: var(--primary-color);\n  border-color: var(--primary-color);\n  color: white;\n  transform: scale(1.15);\n  box-shadow: 0 0 30px rgba(59, 130, 246, 0.5);\n}\n\n.step-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-muted);\n  transition: var(--transition);\n}\n\n.step.active .step-label,\n.step.current .step-label {\n  color: var(--primary-light);\n}\n\n.step-divider {\n  width: 24px;\n  height: 2px;\n  background: var(--border-color);\n  margin: 0 4px;\n  flex-shrink: 0;\n}\n\n.step.active ~ .step-divider {\n  background: var(--primary-color);\n}\n\n/* ==========================================\n   UPLOAD CONTENT LAYOUT\n   =========================================== */\n\n.upload-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  max-width: 1400px;\n  margin: 10px auto;\n}\n\n@media (max-width: 1024px) {\n  .upload-content {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ==========================================\n   CARD STYLES\n   =========================================== */\n\n.upload-card,\n.config-card,\n.log-card {\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);\n  backdrop-filter: blur(10px);\n  overflow: hidden;\n  transition: var(--transition);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.upload-card:hover,\n.config-card:hover,\n.log-card:hover {\n  border-color: var(--border-light);\n  box-shadow: 0 20px 40px rgba(59, 130, 246, 0.1);\n}\n\n.card-header-KB {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-bottom: 1px solid var(--border-color);\n  color: var(--text-primary);\n  position: relative;\n  /* background: #e6eeffeb; */\n  background: linear-gradient(135deg, #dbedff 0%, #f3f4f6 100%);\n}\n\n.card-header-KB h2,\n.card-header-KB h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  flex: 1;\n}\n\n.card-header-KB svg {\n  width: 20px;\n  height: 20px;\n  color: var(--primary-light);\n}\n\n.format-btn {\n  padding: 4px 12px;\n  border: 1px solid var(--border-light);\n  border-radius: 20px;\n  background: transparent;\n  color: var(--primary-light);\n  font-size: 10px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.format-btn:hover {\n  background: rgba(59, 130, 246, 0.05);\n  border-color: var(--primary-light);\n}\n\n/* ==========================================\n   FORMS\n   =========================================== */\n\n.upload-form,\n.config-form {\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n/* .form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.form-group label {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.form-select {\n    padding: 12px 14px;\n    border: 1px solid var(--border-light);\n    border-radius: 8px;\n    background: var(--bg-input);\n    color: var(--text-primary);\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: var(--transition);\n    appearance: none;\n    padding-right: 36px;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%234a4a4a' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n}\n\n.form-select:focus,\n.form-select:hover {\n    border-color: var(--primary-light);\n    background-color: rgba(59, 130, 246, 0.05);\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-select option {\n    background: white;\n    color: var(--text-primary);\n}*/\n\n.material-type-select,\n.depth-select {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.material-type-select svg,\n.depth-select svg {\n  position: absolute;\n  left: 14px;\n  width: 16px;\n  height: 16px;\n  color: var(--primary-light);\n  pointer-events: none;\n}\n\n.material-type-select,\n.depth-select {\n  padding-left: 40px;\n}\n\n.select-icon {\n  position: absolute;\n  right: 12px;\n  width: 18px;\n  height: 18px;\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n/* ==========================================\n   DRAG AND DROP AREA\n   =========================================== */\n\n.drag-drop-area {\n  border: 2px dashed var(--border-light);\n  border-radius: 10px;\n  padding: 5px 5px;\n  text-align: center;\n  cursor: pointer;\n  transition: var(--transition);\n  background: rgba(59, 130, 246, 0.02);\n  position: relative;\n  overflow: hidden;\n}\n\n.drag-drop-area::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(\n    circle at center,\n    rgba(59, 130, 246, 0.03) 0%,\n    transparent 70%\n  );\n  pointer-events: none;\n}\n\n.drag-drop-area.active {\n  border-color: var(--primary-light);\n  background: rgba(59, 130, 246, 0.08);\n  box-shadow: 0 0 30px rgba(59, 130, 246, 0.2);\n}\n\n.drag-drop-area:hover {\n  border-color: var(--primary-color);\n  background: rgba(59, 130, 246, 0.04);\n}\n\n.upload-icon {\n  width: 24px;\n  height: 24px;\n  color: var(--primary-light);\n  margin: 0 auto 16px;\n  opacity: 0.8;\n  transition: var(--transition);\n}\n\n.drag-drop-area:hover .upload-icon,\n.drag-drop-area.active .upload-icon {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.drag-drop-area h3 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.drag-drop-area p {\n  font-size: 12px;\n  color: var(--text-secondary);\n  margin-bottom: 16px;\n}\n\n.format-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n  margin-top: 16px;\n}\n\n.format-badge {\n  padding: 4px 10px;\n  background: rgba(59, 130, 246, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.2);\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--primary-light);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.file-input {\n  display: none;\n}\n\n/* ==========================================\n   URL INPUT SECTION\n   =========================================== */\n\n.url-input-section {\n  padding-top: 16px;\n  border-top: 1px solid var(--border-color);\n}\n\n.url-input-section label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n}\n\n.url-input-group {\n  display: flex;\n  gap: 8px;\n}\n\n.url-input {\n  flex: 1;\n  padding: 10px 14px;\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  background: var(--bg-input);\n  color: var(--text-primary);\n  font-size: 13px;\n  transition: var(--transition);\n}\n\n.url-input:focus {\n  outline: none;\n  border-color: var(--primary-light);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.url-input::placeholder {\n  color: var(--text-muted);\n}\n\n.add-btn {\n  padding: 10px 16px;\n  background: var(--primary-color);\n  border: 1px solid var(--primary-color);\n  border-radius: 8px;\n  color: white;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.add-btn:hover {\n  background: var(--primary-dark);\n  box-shadow: 0 0 20px rgba(59, 130, 246, 0.3);\n}\n\n.add-btn:active {\n  transform: scale(0.98);\n}\n\n/* ==========================================\n   UPLOAD QUEUE\n   =========================================== */\n\n.upload-queue {\n  border-top: 1px solid var(--border-color);\n  padding: 20px;\n  background: rgba(59, 130, 246, 0.02);\n}\n\n.upload-queue h3 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.queue-count {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-bottom: 12px;\n}\n\n.no-files {\n  text-align: center;\n  padding: 24px;\n  color: var(--text-muted);\n  font-size: 13px;\n}\n\n.files-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.files-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.files-list::-webkit-scrollbar-track {\n  background: rgba(59, 130, 246, 0.05);\n  border-radius: 3px;\n}\n\n.files-list::-webkit-scrollbar-thumb {\n  background: rgba(59, 130, 246, 0.3);\n  border-radius: 3px;\n}\n\n.files-list::-webkit-scrollbar-thumb:hover {\n  background: rgba(59, 130, 246, 0.5);\n}\n\n.file-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  background: white;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  transition: var(--transition);\n}\n\n.file-item:hover {\n  background: #fafafa;\n  border-color: var(--border-light);\n}\n\n.file-progress .progress {\n  width: 100%;\n  height: 4px;\n  background: #f1f5f9;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6, #22c55e);\n  /* 🔥 blue → green */\n  transition: width 0.4s ease;\n}\n\n.file-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.file-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n\n.file-info svg {\n  width: 16px;\n  height: 16px;\n  color: var(--primary-light);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.file-details {\n  min-width: 0;\n}\n\n.file-name {\n  max-width: 440px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.file-meta {\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.remove-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: #fef2f2;\n  color: #ef4444;\n  font-size: 18px;\n  font-weight: 600;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.remove-btn:hover {\n  background: #ef4444;\n  color: #fff;\n  transform: scale(1.1);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n.remove-btn:active {\n  transform: scale(0.95);\n}\n\n/* ==========================================\n   EXTRACTION CONFIG\n   =========================================== */\n\n.config-form {\n  padding: 24px;\n}\n\n.year-range {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.year-input {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid var(--border-light);\n  border-radius: 6px;\n  background: var(--bg-input);\n  color: var(--text-primary);\n  font-size: 13px;\n  transition: var(--transition);\n}\n\n.year-input:focus {\n  outline: none;\n  border-color: var(--primary-light);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.year-separator {\n  color: var(--text-muted);\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n/* ==========================================\n   EXTRACTION OPTIONS\n   =========================================== */\n\n.extraction-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  background: rgba(59, 130, 246, 0.03);\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.checkbox-label:hover {\n  color: var(--primary-light);\n}\n\n.checkbox-input {\n  display: none;\n}\n\n.checkbox-custom {\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--border-light);\n  border-radius: 4px;\n  background: white;\n  transition: var(--transition);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.checkbox-input:checked + .checkbox-custom {\n  background: var(--primary-color);\n  border-color: var(--primary-color);\n}\n\n.checkbox-input:checked + .checkbox-custom::after {\n  content: \"✓\";\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.label-text {\n  font-size: 13px;\n  color: var(--text-secondary);\n  transition: var(--transition);\n}\n\n.checkbox-label:hover .label-text {\n  color: var(--text-primary);\n}\n\n/* ==========================================\n   START BUTTON\n   =========================================== */\n\n.start-btn {\n  padding: 12px 20px;\n  background: linear-gradient(\n    135deg,\n    var(--primary-color) 0%,\n    var(--primary-dark) 100%\n  );\n  border: 1px solid var(--primary-light);\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.start-btn:hover {\n  box-shadow: 0 0 30px rgba(59, 130, 246, 0.4);\n  transform: translateY(-2px);\n}\n\n.start-btn:active {\n  transform: translateY(0);\n}\n\n.start-btn svg {\n  width: 18px;\n  height: 18px;\n}\n.start-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n  opacity: 0.6;\n  box-shadow: none;\n}\n\n/* ==========================================\n   PROCESSING LOG\n   =========================================== */\n\n.log-card {\n  display: flex;\n  flex-direction: column;\n  margin-top: 24px;\n  grid-column: 1 / -1;\n  height: stretch;\n}\n\n@media (min-width: 1025px) {\n  .log-card {\n    margin-top: 0;\n    grid-column: 2;\n    grid-row: 2;\n  }\n}\n\n.log-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-color);\n  /* background: #e6eeffeb; */\n  background: linear-gradient(135deg, #dbedff 0%, #f3f4f6 100%);\n}\n\n.log-header h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  flex: 1;\n}\n\n.log-status {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.log-content {\n  padding: 16px;\n  background: #f5f5f5;\n  font-family: \"Courier New\", monospace;\n  font-size: 12px;\n  /* color: var(--primary-color); */\n  max-height: 743px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.log-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.log-content::-webkit-scrollbar-track {\n  background: rgba(59, 130, 246, 0.05);\n}\n\n.log-content::-webkit-scrollbar-thumb {\n  background: rgba(59, 130, 246, 0.2);\n  border-radius: 3px;\n}\n\n.log-line {\n  line-height: 1.8;\n  white-space: pre-wrap;\n  word-break: break-word;\n  margin-bottom: 4px;\n}\n\n.log-line:last-child {\n  margin-bottom: 0;\n}\n\n/* ==========================================\n   CARD STYLES\n   =========================================== */\n\n.quick-templates-card,\n.ai-command-card,\n.advanced-params-card,\n.output-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  /* border-radius: 12px; */\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  transition: var(--transition);\n  position: relative;\n  bottom: 0;\n  right: 0;\n  width: stretch;\n}\n\n.quick-templates-card:hover,\n.ai-command-card:hover,\n.advanced-params-card:hover,\n.output-card:hover {\n  border-color: var(--primary-light);\n  box-shadow: 0 12px 24px rgba(37, 99, 235, 0.12);\n}\n\n.card-header-Ai {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: linear-gradient(135deg, #dbedff 0%, #f3f4f6 100%);\n  border-bottom: 1px solid var(--border-color);\n  position: relative;\n  /* border-top-left-radius: 5px;\n  border-top-right-radius: 5px; */\n}\n\n.header-icon {\n  width: 18px;\n  height: 18px;\n  color: var(--primary-color);\n  flex-shrink: 0;\n}\n\n.card-header-Ai h2 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary);\n  flex: 1;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n/* .claude-response {\n  height: 100vh;\n  overflow: auto;\n} */\n\n/* ==========================================\n   AI COMMAND CARD\n   =========================================== */\n\n.command-input-section {\n  padding: 16px;\n}\n\n.input-wrapper {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  /* margin-bottom: 16px; */\n}\n\n.command-input {\n  flex: 1;\n  padding: 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-input);\n  color: var(--text-primary);\n  font-size: 13px;\n  font-family: \"Segoe UI\", Roboto, sans-serif;\n  resize: vertical;\n  min-height: 100px;\n  transition: var(--transition);\n}\n\n.command-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  background: white;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.command-input::placeholder {\n  color: var(--text-light);\n}\n\n.send-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: none;\n  background: linear-gradient(135deg, #abaeff, #4f46e5);\n  color: white;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);\n}\n\n/* Hover */\n.send-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(99, 102, 241, 0.4);\n}\n\n/* Click */\n.send-btn:active {\n  transform: scale(0.95);\n}\n\n/* Disabled */\n.send-btn:disabled {\n  background: #e5e7eb;\n  color: #9ca3af;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.input-hint {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-bottom: 3px;\n  font-weight: 600;\n}\n\n/* ==========================================\n   EXECUTE BUTTON\n   =========================================== */\n\n.execute-btn {\n  padding: 9px 20px;\n  /* margin: 0 16px 20px; */\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: calc(100% - 48px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.execute-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);\n}\n\n.execute-btn:active {\n  transform: translateY(0);\n}\n\n.execute-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n.execute-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.trash-icon {\n  /* position: absolute; */\n  /* right: 20px;\n    bottom: 20px; */\n  padding: 8px;\n  background: var(--bg-input);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: var(--transition);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.trash-icon:hover {\n  background: #fee2e2;\n  border-color: var(--error);\n  color: var(--error);\n}\n\n/* ==========================================\n   RESPONSIVE DESIGN\n   =========================================== */\n\n@media (max-width: 1024px) {\n  .knowledge-upload-container {\n    padding: 24px 16px;\n  }\n\n  .header-title {\n    font-size: 24px;\n  }\n\n  .upload-content {\n    gap: 16px;\n  }\n\n  .log-card {\n    grid-column: 1 / -1;\n    margin-top: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .knowledge-upload-container {\n    padding: 16px 12px;\n  }\n\n  .upload-header {\n    padding: 16px;\n    margin-bottom: 24px;\n  }\n\n  .header-title {\n    font-size: 20px;\n  }\n\n  .header-description {\n    font-size: 13px;\n  }\n\n  .steps-container {\n    gap: 8px;\n    margin-bottom: 24px;\n  }\n\n  .upload-form,\n  .config-form {\n    gap: 16px;\n  }\n\n  .drag-drop-area {\n    padding: 32px 16px;\n  }\n\n  .url-input-group {\n    flex-direction: column;\n  }\n\n  .add-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .year-range {\n    flex-wrap: wrap;\n  }\n\n  .year-input {\n    flex: 1;\n    min-width: 100px;\n  }\n}\n\n/* ==========================================\n   ANIMATIONS\n   =========================================== */\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.knowledge-upload-container {\n  animation: slideIn 0.6s ease-out;\n}\n\n.step {\n  animation: slideIn 0.6s ease-out backwards;\n}\n\n.step:nth-child(odd) {\n  animation-delay: 0.1s;\n}\n\n.step:nth-child(even) {\n  animation-delay: 0.2s;\n}\n\n/* ==========================================\n   UTILITY CLASSES\n   =========================================== */\n\n.opacity-50 {\n  opacity: 0.5;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.transition-all {\n  transition: var(--transition);\n}\n\n.image-card {\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: 12px;\n  overflow: hidden;\n  position: relative;\n  background: #ffffff;\n  border: 1px solid #c6c6c6;\n  cursor: default;\n  transition: 0.25s ease;\n}\n\n.image-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 0px 10px rgb(0 0 0 / 12%);\n  border-color: #4f8cff;\n  border-width: 2px;\n}\n\n.image-card.editing {\n  border: 2px solid #4f8cff;\n  cursor: pointer;\n}\n\n/* Image */\n.image-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  max-width: 270px;\n}\n\n/* Placeholder */\n.placeholder {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #aaa;\n}\n\n.plus {\n  font-size: 26px;\n  margin-bottom: 6px;\n}\n\n/* Overlay Button */\n.overlay {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  opacity: 0;\n  transition: 0.2s ease;\n}\n\n.image-card:hover .overlay {\n  opacity: 1;\n}\n\n.overlay button:hover {\n  background: rgb(195, 246, 255);\n  border: 1px solid #00b1cc;\n}\n\n.overlay button {\n  background: rgb(255 255 255);\n  border: none;\n  border-radius: 19%;\n  padding: 6px 8px;\n  color: #fff;\n  cursor: pointer;\n  font-size: 14px;\n  border: 1px solid #414141;\n}\n\n.overlay button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.image-card.editing .overlay {\n  opacity: 1;\n}\n\n.pagination-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 15px 0;\n}\n\n.page-btn {\n  min-width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: #414141;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.page-btn:hover {\n  background: #78909c59;\n  font-weight: 600;\n}\n\n.page-btn.active {\n  background: #2563eb;\n  color: #fff;\n  font-weight: 600;\n}\n\n.nav-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  border: none;\n  background: #2461e5;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nav-btn:hover {\n  background: #ffffff;\n  color: #2461e5;\n  border: 2px solid #2461e5;\n}\n\n.nav-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
